import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Input from '../generic/Input'
import Button from '../generic/Button'
import Switch from '@material-ui/core/Switch'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { getModel, updateModel } from '../data/Model'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import { requestAPI, requestAPIWithFormData } from '../data/api.js'
import { getSelectedClients } from '../data/interactions'
import { formatClientData } from '../lib/formatClientData'
import MetadataMappings from './metadataMappings'
import Dropzone from 'react-dropzone'
import PublishIcon from '@material-ui/icons/Publish'

class Settings extends Component {
	// --- Client groups Handlers ---
	handleAddGrouping = async (e) => {
		e.preventDefault()
		const { activeClient, newGroupingName } = this.state
		if (!newGroupingName) return
		this.setState({ addingGrouping: true })
		try {
			await requestAPI(
				`/hubs/group/${activeClient.client_id}/${encodeURIComponent(newGroupingName)}`,
				'POST',
			)
			// Refresh groups in state
			const updated = await getClientSettings(activeClient.client_id)
			const formattedClient = formatClientData(updated)
			this.setState({
				formattedClient,
				newGroupingName: '',
				addingGrouping: false,
			})
		} catch (err) {
			window.alert('Failed to add group')
			this.setState({ addingGrouping: false })
		}
	}

	handleDeleteGrouping = async (groupName) => {
		const { activeClient } = this.state
		this.setState({ deletingGrouping: groupName })
		try {
			await requestAPI(
				`/hubs/group/${activeClient.client_id}/${encodeURIComponent(groupName)}`,
				'DELETE',
			)
			// Refresh groups in state
			const updated = await getClientSettings(activeClient.client_id)
			const formattedClient = formatClientData(updated)
			this.setState({
				formattedClient,
				deletingGrouping: null,
			})
		} catch (err) {
			window.alert('Failed to delete group')
			this.setState({ deletingGrouping: null })
		}
	}
	constructor(props, context) {
		super(props, context)
		const client = { ...getSelectedClients()[0] }
		delete client.active

		this.state = {
			activeClient: client,
			formattedClient: {
				client: {},
				settings: {},
				targets: {},
				filters: {},
			},
			changesToSave: {},
			saving: false,
			agreementFile: null,
			uploadingAgreement: false,
			agreementVrgFile: null,
			uploadingAgreementVrg: false,
		}
	}

	componentDidMount = () => {
		let clientDataPromise
		let clientData

		if (
			getModel().clients.status.handle === 'not-loaded' ||
			!this.state.formattedClient.settings.client
		) {
			clientDataPromise = getClientSettings(this.state.activeClient.client_id)
				.then((r) => {
					clientData = r
					const formattedClient = formatClientData(clientData)
					this.setState({ formattedClient })
				})
				.catch((e) => console.log(e))
		}
	}

	handleSave = async () => {
		this.setState({
			saving: true,
		})

		const client_id = this.state.activeClient.client_id

		const client = this.state.changesToSave.client
		if (client && client.website && !URL.canParse(client.website)) {
			window.alert('Please enter a valid website URL')
			this.setState({
				saving: false,
			})
			return
		}

		if (client_id) {
			await updateClient({
				...this.state.changesToSave,
				client_id,
			})
			this.setState({
				saving: false,
				changesToSave: {},
			})
		}
	}

	handleChange = (e, value) => {
		e.persist()
		const [section, key] = e.target.name.split('.')
		this.setState((prev) => ({
			...prev,
			formattedClient: {
				...prev.formattedClient,
				[section]: {
					...prev.formattedClient[section],
					[key]: value,
				},
			},
			changesToSave: {
				...prev.changesToSave,
				[section]: {
					...prev.changesToSave[section],
					[key]: value,
				},
			},
		}))
	}

	handleImageUrlPatternChange = (e) => {
		if (e.target.value === '') {
			this.setState({
				formattedClient: {
					...this.state.formattedClient,
					client: {
						...this.state.formattedClient.client,
						image_archive_url_pattern: '',
						show_image_ownership: false,
					},
				},
				changesToSave: {
					...this.state.changesToSave,
					client: {
						...this.state.changesToSave.client,
						image_archive_url_pattern: '',
						show_image_ownership: false,
					},
				},
			})
			return
		}

		this.handleChange(e, e.target.value)
	}

	handleAgreementDrop = ({ acceptedFiles, agreementFileKey }) => {
		if (!acceptedFiles || acceptedFiles.length === 0) return
		const file = acceptedFiles[0]
		if (file.type !== 'application/pdf') {
			window.alert('Only PDF files are allowed')
			return
		}
		this.setState({ [agreementFileKey]: file })
	}

	handleAgreementUpload = async ({ agreementKey, agreementFileKey }) => {
		const { activeClient } = this.state
		const agreementFile = this.state[agreementFileKey]
		if (!agreementFile) return

		const MAX_AGREEMENT_FILE_SIZE = 15 * 1024 * 1024 // 15MB

		if (agreementFile.type !== 'application/pdf') {
			window.alert('Agreement must be a PDF file')
			return
		}
		if (agreementFile.size > MAX_AGREEMENT_FILE_SIZE) {
			window.alert('Agreement PDF exceeds size limit of 15MB')
			return
		}

		this.setState({ uploadingAgreement: true })
		const response = await uploadAgreement({
			client_id: activeClient.client_id,
			file: agreementFile,
			agreementType: agreementKey === 'agreement_gcs_uri' ? 'ca' : 'vrg',
		})

		if (!response.agreement_gcs_uri && !response.agreement_vrg_gcs_uri) {
			window.alert('Failed to upload agreement file')
			this.setState({ uploadingAgreement: false })
			throw new Error('Upload failed')
		}

		this.setState((prev) => ({
			formattedClient: {
				...prev.formattedClient,
				client: {
					...prev.formattedClient.client,
					...response,
				},
			},
			[agreementFileKey]: null,
		}))
		updateModel((model) => {
			model.clients.data = model.clients.data.map((c) => {
				if (c.client_id === activeClient.client_id) {
					return { ...c, [agreementKey]: response.agreement }
				}
				return c
			})
			return model
		})

		this.setState({ uploadingAgreement: false })
	}

	handleAgreementDelete = async ({ agreementKey, agreementFileKey }) => {
		const { activeClient } = this.state

		const queryParams = {}

		if (getSelectedClients().length > 0) {
			queryParams.clientId = getSelectedClients()[0].client_id
		} else {
			throw new Error('No client id found')
		}

		const urlParams = new URLSearchParams(queryParams).toString()

		const response = await requestAPI(`/agreements?${urlParams}`, 'DELETE', {
			agreementType: agreementKey === 'agreement_gcs_uri' ? 'ca' : 'vrg',
		})
		console.log(response)
		if (!response.ok) {
			window.alert('Failed to delete agreement file')
			throw new Error('Delete failed')
		}

		this.setState((prev) => ({
			formattedClient: {
				...prev.formattedClient,
				client: {
					...prev.formattedClient.client,
					[agreementKey]: null,
				},
			},
			[agreementFileKey]: null,
		}))
		updateModel((model) => {
			model.clients.data = model.clients.data.map((c) => {
				if (c.client_id === activeClient.client_id) {
					return { ...c, [agreementKey]: null }
				}
				return c
			})
			return model
		})
	}

	convertGcsUriToPublicUrl = (gcsUri) => {
		return gcsUri.replace('gs://', 'https://storage.googleapis.com/')
	}

	render() {
		const clientForm = this.state.formattedClient
		const activeClient = this.state.activeClient
		const {
			agreementFile,
			uploadingAgreement,
			agreementVrgFile,
			uploadingAgreementVrg,
		} = this.state

		return (
			<div className='container' style={{ paddingBottom: '100px' }}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<h1 style={{ marginTop: '30px', marginBottom: '20px' }}>Settings</h1>
					<Button onClick={this.handleSave}>Save</Button>
				</div>
				<h2>
					{this.state.saving && '(Saving..)'}
					{uploadingAgreement && ' (Uploading agreement...)'}
				</h2>
				<h3>Client Id</h3>
				<Input
					name='client.client_id'
					value={activeClient.client_id}
					disabled
				/>
				<h3>Name</h3>
				<Input
					name='client.name'
					placeholder='Name'
					value={clientForm.client.name || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
				<h3>Short Name</h3>
				<Input
					name='client.short_name'
					placeholder='Short Name'
					value={clientForm.client.short_name || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
				<h3>Bucket Prefix</h3>
				<Input
					name='client.bucket_prefix'
					placeholder='Folder in bucket'
					value={clientForm.client.bucket_prefix || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>

				{/* Client groups Section */}
				<h3>Client groups</h3>
				<div style={{ marginBottom: '20px' }}>
					<form
						onSubmit={this.handleAddGrouping}
						style={{ display: 'flex', alignItems: 'center', gap: 8 }}
					>
						<Input
							name='new_grouping_name'
							placeholder='Add new group'
							value={this.state.newGroupingName || ''}
							onChange={(e) =>
								this.setState({ newGroupingName: e.target.value })
							}
							style={{ width: 200 }}
						/>
						<Button
							type='submit'
							disabled={
								!this.state.newGroupingName || this.state.addingGrouping
							}
						>
							{this.state.addingGrouping ? 'Adding...' : 'Add'}
						</Button>
					</form>
					<table
						style={{ width: '100%', marginTop: 12, borderCollapse: 'collapse' }}
					>
						<thead>
							<tr style={{ background: '#f5f5f5' }}>
								<th style={{ textAlign: 'left', padding: 8 }}>Group Name</th>
								<th style={{ textAlign: 'left', padding: 8 }}>Actions</th>
							</tr>
						</thead>
						<tbody>
							{(clientForm.client.groups || []).map((group_name, idx) => (
								<tr key={group_name} style={{ borderBottom: '1px solid #eee' }}>
									<td style={{ padding: 8 }}>{group_name}</td>
									<td style={{ padding: 8 }}>
										<Button
											style={{ background: '#ff4646', minWidth: 80 }}
											onClick={() => this.handleDeleteGrouping(group_name)}
											disabled={this.state.deletingGrouping === group_name}
										>
											{this.state.deletingGrouping === group_name
												? 'Deleting...'
												: 'Delete'}
										</Button>
									</td>
								</tr>
							))}
							{(!clientForm.client.groups ||
								clientForm.client.groups.length === 0) && (
								<tr>
									<td colSpan={2} style={{ padding: 8, color: '#888' }}>
										No groups
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
				<h3>Agreement</h3>
				{clientForm.client.agreement_gcs_uri ? (
					<p>
						Current agreement URL:{' '}
						<a
							href={this.convertGcsUriToPublicUrl(
								clientForm.client.agreement_gcs_uri,
							)}
							target='_blank'
							rel='noreferrer'
							style={{ color: '#007bff' }}
						>
							{this.convertGcsUriToPublicUrl(
								clientForm.client.agreement_gcs_uri,
							)}
						</a>
					</p>
				) : (
					<p>No agreement uploaded yet.</p>
				)}
				<Dropzone
					multiple={false}
					accept='application/pdf'
					onDrop={(acceptedFiles) => {
						this.handleAgreementDrop({
							acceptedFiles,
							agreementFileKey: 'agreementFile',
						})
					}}
					style={{
						border: '3px dashed #ddd',
						padding: '40px 15px',
						textAlign: 'center',
						marginBottom: '10px',
						background: '#fafafa',
						cursor: 'pointer',
					}}
				>
					<PublishIcon />
					<br />
					{agreementFile ? (
						<>
							<strong>Selected file:</strong>
							<br />
							{agreementFile.name}
						</>
					) : (
						<>
							<strong>Drop agreement PDF here</strong>
							<br />
							<span>or click to browse (max 15MB, .pdf)</span>
						</>
					)}
				</Dropzone>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '10px',
						marginBottom: '30px',
					}}
				>
					{clientForm.client.agreement_gcs_uri && (
						<Button
							style={{ background: '#ff4646' }}
							onClick={() =>
								this.handleAgreementDelete({
									agreementKey: 'agreement_gcs_uri',
									agreementFileKey: 'agreementFile',
								})
							}
						>
							Remove File
						</Button>
					)}
					<Button
						onClick={() =>
							this.handleAgreementUpload({
								agreementKey: 'agreement_gcs_uri',
								agreementFileKey: 'agreementFile',
							})
						}
						disabled={!agreementFile || uploadingAgreement}
					>
						{uploadingAgreement ? 'Uploading...' : 'Upload Agreement'}
					</Button>
				</div>
				<h3>VRG Agreement</h3>
				{clientForm.client.agreement_vrg_gcs_uri ? (
					<p>
						Current VRG agreement URL:{' '}
						<a
							href={this.convertGcsUriToPublicUrl(
								clientForm.client.agreement_vrg_gcs_uri,
							)}
							target='_blank'
							rel='noreferrer'
							style={{ color: '#007bff' }}
						>
							{this.convertGcsUriToPublicUrl(
								clientForm.client.agreement_vrg_gcs_uri,
							)}
						</a>
					</p>
				) : (
					<p>No VRG agreement uploaded yet.</p>
				)}
				<Dropzone
					multiple={false}
					accept='application/pdf'
					onDrop={(acceptedFiles) => {
						this.handleAgreementDrop({
							acceptedFiles,
							agreementFileKey: 'agreementVrgFile',
						})
					}}
					style={{
						border: '3px dashed #ddd',
						padding: '40px 15px',
						textAlign: 'center',
						marginBottom: '10px',
						background: '#fafafa',
						cursor: 'pointer',
					}}
				>
					<PublishIcon />
					<br />
					{agreementVrgFile ? (
						<>
							<strong>Selected file:</strong>
							<br />
							{agreementVrgFile.name}
						</>
					) : (
						<>
							<strong>Drop VRG agreement PDF here</strong>
							<br />
							<span>or click to browse (max 15MB, .pdf)</span>
						</>
					)}
				</Dropzone>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '10px',
						marginBottom: '30px',
					}}
				>
					{clientForm.client.agreement_vrg_gcs_uri && (
						<Button
							style={{ background: '#ff4646' }}
							onClick={() =>
								this.handleAgreementDelete({
									agreementKey: 'agreement_vrg_gcs_uri',
									agreementFileKey: 'agreementVrgFile',
								})
							}
						>
							Remove File
						</Button>
					)}
					<Button
						onClick={() =>
							this.handleAgreementUpload({
								agreementKey: 'agreement_vrg_gcs_uri',
								agreementFileKey: 'agreementVrgFile',
							})
						}
						disabled={!agreementVrgFile || uploadingAgreementVrg}
					>
						{uploadingAgreementVrg ? 'Uploading...' : 'Upload VRG Agreement'}
					</Button>
				</div>
				<h3>Website</h3>
				<Input
					name='client.website'
					value={clientForm.client.website || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
				<h3>Website used for VRG CPUI </h3>
				<Input
					name='client.website_vrg'
					value={clientForm.client.website_vrg || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
				<h3>Logo</h3>
				<Input
					name='client.logo'
					value={clientForm.client.logo || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
				<h3>Image archive URL pattern</h3>
				<p>
					Please add {'{{imageId}}'} to the part of the URL where the image ID
					should be inserted
				</p>
				<Input
					name='client.image_archive_url_pattern'
					placeholder='URL Pattern'
					value={clientForm.client.image_archive_url_pattern || ''}
					onChange={(e) => this.handleImageUrlPatternChange(e)}
				/>
				{!!this.state.formattedClient.client.image_archive_url_pattern ? (
					<React.Fragment>
						<h3>Show Image Ownership</h3>
						<p>
							Use the image archive URL pattern as the verify image ownership
							URL
						</p>
						<Switch
							name='client.show_image_ownership'
							checked={!!clientForm.client.show_image_ownership}
							onChange={(e) => this.handleChange(e, e.target.checked)}
							color='primary'
						/>
					</React.Fragment>
				) : null}
				<h3>Description</h3>
				<Input
					name='client.description'
					value={clientForm.client.description || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
				<hr />
				<h3>Agency Byline Names</h3>
				<Input
					name='settings.byline_names'
					placeholder='Example Agency,Example,Agency'
					value={clientForm.settings.byline_names || ''}
					onChange={(e) =>
						this.handleChange(
							e,
							e.target.value ? e.target.value.split(',') : null,
						)
					}
				/>
				<h3>Case reviewed monthly target</h3>
				<Input
					type='number'
					name='targets.reviewed_cases_monthly_target'
					value={clientForm.targets.reviewed_cases_monthly_target || ''}
					onChange={(e) => this.handleChange(e, +e.target.value || 0)}
				/>
				<h3>Notify on Slack</h3>
				<Switch
					name='settings.notify_on_slack'
					checked={!!clientForm.settings.notify_on_slack}
					onChange={(e) => this.handleChange(e, e.target.checked)}
					color='primary'
				/>
				<h3>Main Client</h3>
				<Switch
					name='client.is_main_client'
					checked={!!clientForm.client.is_main_client}
					onChange={(e) => this.handleChange(e, e.target.checked)}
					color='primary'
				/>
				<h3>Inactive</h3>
				<Switch
					name='client.inactive'
					checked={!!clientForm.client.inactive}
					onChange={(e) => this.handleChange(e, e.target.checked)}
					color='primary'
				/>
				<h3>Pause Scans</h3>
				<Switch
					name='client.scans_paused'
					checked={!!clientForm.client.scans_paused}
					onChange={(e) => this.handleChange(e, e.target.checked)}
					color='primary'
				/>
				<h3>Soft Claim</h3>
				<FormGroup>
					<FormControlLabel
						control={
							<Switch
								name='settings.soft_claim'
								checked={!!clientForm.settings.soft_claim}
								onChange={(e) => this.handleChange(e, e.target.checked)}
								color='primary'
							/>
						}
						label='Enable and show the Soft Claim option on the clients cases'
					/>
				</FormGroup>
				<h3>Registration Certificates</h3>
				<FormGroup>
					<FormControlLabel
						control={
							<Switch
								name='settings.registration_certificates_enabled'
								checked={
									!!clientForm.settings.registration_certificates_enabled
								}
								onChange={(e) => this.handleChange(e, e.target.checked)}
								color='primary'
							/>
						}
						label='Enable Registration Certificates view in Partner Interface'
					/>
				</FormGroup>
				<h3>Transfer of Rights Agreement</h3>
				<FormGroup>
					<FormControlLabel
						control={
							<Switch
								name='settings.transfer_agreements_enabled'
								checked={!!clientForm.settings.transfer_agreements_enabled}
								onChange={(e) => this.handleChange(e, e.target.checked)}
								color='primary'
							/>
						}
						label='Enable Transfer of Rights Agreement view in Partner Interface'
					/>
				</FormGroup>
				<h3>Force Upload to Registered Image Pipeline</h3>
				<FormGroup>
					<FormControlLabel
						control={
							<Switch
								name='settings.force_upload_to_registered_image_pipeline_enabled'
								checked={
									!!clientForm.settings
										.force_upload_to_registered_image_pipeline_enabled
								}
								onChange={(e) => this.handleChange(e, e.target.checked)}
								color='primary'
							/>
						}
						label="Forces upload of cases to the Registered Image Pipeline in Pipedrive regardless of the case's registration status."
					/>
				</FormGroup>
				<h3>Currency</h3>
				<FormControl>
					<Select
						native
						name='settings.currency'
						value={clientForm.settings.currency || ''}
						onChange={(e) => this.handleChange(e, e.target.value)}
					>
						<option value='' />
						<option value='DKK'>DKK</option>
						<option value='EUR'>EUR</option>
						<option value='NOK'>NOK</option>
						<option value='SEK'>SEK</option>
						<option value='GBP'>GBP</option>
					</Select>
				</FormControl>
				<h3>Partner Type</h3>
				<FormControl>
					<Select
						native
						name='settings.partner_type'
						value={clientForm.settings.partner_type || ''}
						onChange={(e) => this.handleChange(e, e.target.value)}
					>
						<option value=''>Select Partner Type</option>
						<option value='IMAGE_AGENCY'>Image Agency</option>
						<option value='INFLUENCER'>Influencer</option>
					</Select>
				</FormControl>
				<MetadataMappings clientId={activeClient.client_id} />
				<hr />
				<h3>Organization Information</h3>
				<br />
				<p>Organization number</p>
				<Input
					type='text'
					name='settings.organization_number'
					value={clientForm.settings.organization_number || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
				<p>Address</p>
				<Input
					type='text'
					name='settings.address'
					value={clientForm.settings.address || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
				<p>City</p>
				<Input
					type='text'
					name='settings.city'
					value={clientForm.settings.city || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
				<p>Postal Code</p>
				<Input
					type='text'
					name='settings.postal_code'
					value={clientForm.settings.postal_code || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
				<p>Country</p>
				<Input
					type='text'
					name='settings.country_name'
					value={clientForm.settings.country_name || ''}
					onChange={(e) => this.handleChange(e, e.target.value)}
				/>
			</div>
		)
	}
}

Settings.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

function getClientSettings(client_id) {
	return requestAPI(`/hubs/settings/${client_id}`, 'GET')
}

function updateClient(client) {
	return requestAPI('/hubs/update', 'POST', client).then((newClient) => {
		updateModel((model) => {
			model.clients.data = model.clients.data.map((currClient) => {
				if (currClient.client_id === newClient.client_id) return newClient
				return currClient
			})
			model.clients.data.clients = model.clients.data.hubs // TODO remove this dirty fix
			return model
		})
	})
}

// Upload agreement PDF to backend (assumed endpoint). Backend should return { agreement: url, client_id }
function uploadAgreement({ client_id, file, agreementType }) {
	if (agreementType !== 'vrg' && agreementType !== 'ca') {
		throw new Error('Invalid agreement type')
	}

	const queryParams = {}

	if (getSelectedClients().length > 0) {
		queryParams.clientId = getSelectedClients()[0].client_id
	} else {
		throw new Error('No client id found')
	}

	const urlParams = new URLSearchParams(queryParams).toString()

	const formData = new FormData()
	formData.append('agreement_type', agreementType)
	formData.append('file', file)
	return requestAPIWithFormData(`/agreements?${urlParams}`, 'POST', formData)
}

export default Settings
